import DOMPurify from 'dompurify'

const SANITIZE_CONFIG: DOMPurify.Config = {
  USE_PROFILES: { html: true, svg: true, svgFilters: true },
}

/** Nettoie le HTML avant injection via v-html (contenu admin, tooltips, icônes SVG). */
export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, SANITIZE_CONFIG)
}
